<script>
	export let id = getRandomInt(999);
	export let val = 0;
	export let ariaLabel = '';
	let offset = 0;
	let r = 90;
	let c = Math.PI*(r*2);
	let newOffset;

	function getRandomInt(max) {
		return Math.floor(Math.random() * Math.floor(max));
	}

	function updateDonut(val) {
		if (isNaN(val)) {
			// val = 100; 
		}
		else{
			newOffset = ((100-val)/100)*c;
			return ((100-val)/100)*c;
		}
	}

	$: offset = updateDonut(val);
</script>

<div id="{ id }" class="uc-donut-chart" data-pct="{ val }">
  <svg id="svg-{ id }" aria-label="{ ariaLabel }" width="200" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <circle r="{r}" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0"></circle>
    <circle id="bar-{ id }" class="bar" r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0" style="stroke-dashoffset:{ offset };"></circle>
  </svg>
</div>

<style>
	.uc-donut-chart {
		display: block;
		height: 200px;
		width: 200px;
		margin: 2rem auto;
		border-radius: 100%;
		position: relative;
		font-weight: bold;
	}

	.uc-donut-chart:after {
		position: absolute;
		display: flex;
		height: 100%;
		width: 100%;
		left: 0;
		top: 0;
		content: attr(data-pct)"%";
		border-radius: 100%;
		font-size: 5rem;
		align-items: center;
		justify-content: center;
	}

	.uc-donut-chart svg circle {
		stroke-dashoffset: 0;
		transition: stroke-dashoffset 1s linear;
		stroke: #3F3F3F;
		stroke-width: 1em;
	}
	.uc-donut-chart svg circle.bar {
		stroke: #e00122;
		stroke-linecap: round;
	}
</style>